import(/* webpackMode: "eager" */ "/builds/empiriecom/core/frontend/turborepo/apps/order/src/app/[lang]/not-found.tsx");
